Promise.all([
    import("flash-message").then(dep => dep.default),
    import("tap-modal/tap-modal").then(dep => dep.default),
    import("utils/router.js").then(dep => dep.default),
    import("angular").then(dep => dep.default),
]).then(deps => {
    let [showFlash, showModal, Routing] = deps;

    var app = angular.module("tapAssetManager");

    app.controller("newViewCtrl", [
        "$scope",
        "assetStorage",
        "$http",
        "sharerTwitter",
        function($scope, assetStorage, $http, sharerTwitter) {
            "use strict";

            $scope.asset = {
                type: "image_banner",
            };

            $scope.updatingCount = 0;
            $scope.maxCount = 0;

            function updateCompleted(err) {
                $scope.updatingCount--;

                // TODO: Check all completed items for errors
                if ($scope.updatingCount === 0 && !err) {
                    showFlash("success", "Saved " + $scope.maxCount + " asset" + ($scope.maxCount > 1 ? "s" : ""));

                    $scope.asset = {
                        type: $scope.asset.type,
                    };

                    angular.forEach($scope.assetFiles.getFiles(), function(dropletFile) {
                        dropletFile.deleteFile();
                    });

                    $scope.assetForm.$setPristine();
                }
            }

            $scope.submit = function() {
                if ($scope.asset.labels_input) {
                    $scope.asset.labels = $scope.asset.labels_input.split(",");
                }

                if ($scope.asset.type === "image_banner") {
                    var files = $scope.assetFiles.getFiles($scope.assetFiles.FILE_TYPES.VALID);

                    // Quick fix: Make sure to save one banner first and then the rest.
                    // This is to prevent race conditions with duplicate labels.
                    // TODO: More elegant solution
                    var numberOfFiles = files.length;
                    if (numberOfFiles > 0) {
                        $scope.updatingCount += numberOfFiles;
                        var firstDropletItem = files.shift();

                        assetStorage.post($scope.asset, firstDropletItem.file, function(err) {
                            updateCompleted(err);

                            angular.forEach(files, function(dropletItem) {
                                assetStorage.post($scope.asset, dropletItem.file, function(err) {
                                    updateCompleted(err);
                                });
                            });
                        });
                    }

                    return;
                }

                if ($scope.asset.type === "html5_banner") {
                    var buttons = [
                        {
                            text: "Save",
                            classes: "btn btn-success will-load",
                            attr: {
                                "data-dismiss": false,
                                disabled: true,
                            },
                            callback: function($dia) {
                                $dia.find(".will-load").addClass("loading");
                                $dia.find(".btn").prop("disabled", true);
                                $scope.updatingCount++;
                                assetStorage.post($scope.asset, null, function(err) {
                                    updateCompleted(err);
                                    $dia.modal("hide");
                                });
                            },
                        },
                        {
                            text: "Cancel",
                        },
                    ];

                    var $dialog = showModal(
                        "Detecting click tags",
                        '<div style="width:100%; height:20rem"><div class="spinner"></div></div>',
                        null,
                        buttons,
                    );

                    $http
                        .post(
                            Routing.generate("tap_program_frontend_ai_asset_gethtml5bannerproperties"),
                            $scope.asset.content,
                        )
                        .success(function(data) {
                            var clickTags = data.clickTags !== null ? Object.keys(data.clickTags) : {};
                            var dimensions = data.dimensions !== null ? Object.keys(data.dimensions) : {};
                            if (!clickTags.length) {
                                if (!clickTags.length && !dimensions.length) {
                                    var message = "<p>No click tags and dimensions ";
                                    var title = "No Click Tags and Dimensions Detected";
                                } else if (!clickTags.length) {
                                    var message = "<p>No click tags ";
                                    var title = "No Click Tags Detected";
                                } else if (!dimensions.length) {
                                    var message = "<p>No dimensions ";
                                    var title = "No Dimensions Detected";
                                }

                                message +=
                                    'were detected. Html5 assets without click tags cannot be submitted</p><p>Please refer to <a href="{{ path("tap_knowledgebase_frontend_article_show", {"slug": "coding-up-html5-banners-for-use-with-tapfiliate"}) }}" target="_blank">our guide</a> to see how to properly code up Html5 banners for use with Tapfiliate.</p>';
                            } else {
                                var title =
                                    "Hurray! " +
                                    clickTags.length +
                                    " click tag " +
                                    (clickTags.length > 1 ? "s" : "") +
                                    " found";
                                var message = "<p>The following click tags were detected:</p>";
                                message += '<table class="table table-striped">';

                                for (var i = 0; i < clickTags.length; i++) {
                                    message +=
                                        "<tr><td><strong>" +
                                        clickTags[i] +
                                        ":</strong></td><td>" +
                                        data.clickTags[clickTags[i]] +
                                        "</td></tr>";
                                }

                                message += "</table>";

                                if (dimensions.length) {
                                    message +=
                                        '<p class="spaced-top">Next to that, we have detected the following dimensions:</p><table class="table table-striped">';
                                    message +=
                                        "<tr><td><strong>Width:</strong></td><td>" +
                                        data.dimensions.width +
                                        "</td></tr>";
                                    message +=
                                        "<tr><td><strong>Height:</strong></td><td>" +
                                        data.dimensions.height +
                                        "</td></tr>";
                                }

                                $dialog.find(".btn-success").prop("disabled", false);
                            }

                            $dialog.setTitle(title);
                            $dialog.setContent(message);
                        });

                    return;
                }

                $scope.updatingCount++;

                assetStorage.post($scope.asset, null, function(err) {
                    updateCompleted(err);
                });
            };

            $scope.getShowableFiles = function() {
                return $scope.assetFiles.getFiles(
                    $scope.assetFiles.FILE_TYPES.VALID | $scope.assetFiles.FILE_TYPES.INVALID,
                );
            };

            const allowedExtensions = ["png", "jpg", "jpeg", "gif"];

            $scope.$on("$dropletReady", function whenDropletReady() {
                $scope.assetFiles.allowedExtensions(allowedExtensions);
                $scope.assetFiles.maximumValidFiles = 100;
            });

            var maxSize = $scope.assetSizeFactor * 150;
            $scope.$on("$dropletFileAdded", function onFileAdd(event, dropletItem) {
                if (allowedExtensions.indexOf(dropletItem.extension) === -1) {
                    dropletItem.invalidMessage = `Invalid: Only png, jpg and gif are allowed`;
                }

                if (dropletItem.file.size / 1024 > maxSize) {
                    dropletItem.setType($scope.assetFiles.FILE_TYPES.INVALID);
                    dropletItem.invalidMessage =
                        "Invalid: This file exceeds the maximum file size of " + maxSize + "kb";
                }

                angular.forEach($scope.getShowableFiles(), function(di) {
                    if (di.$$hashKey === dropletItem.$$hashKey) return;

                    var existingFile = di.file;
                    var newFile = dropletItem.file;

                    if (existingFile.lastModified === newFile.lastModified && existingFile.name === newFile.name) {
                        dropletItem.setType($scope.assetFiles.FILE_TYPES.INVALID);
                        dropletItem.invalidMessage = "Invalid: Duplicate file";
                    }
                });
            });

            $scope.$watch("updatingCount", function(newVal, oldVal) {
                if (newVal > oldVal || (oldVal === 0 && newVal > 0)) {
                    $scope.maxCount = newVal;
                }

                $scope.newViewUpdating = newVal > 0;
            });

            $scope.isTweetWithinMaxCharacters = function() {
                var maxCharacters = 280 - 1 - sharerTwitter.shortUrlLength;

                return ($scope.asset.content ? $scope.asset.content.length : 0) <= maxCharacters;
            };

            $scope.getTweetCharacterCount = function() {
                var count = sharerTwitter.shortUrlLength + 1 + ($scope.asset.content ? $scope.asset.content.length : 0);

                return count;
            };

            $scope.getShortUrlLength = function() {
                return sharerTwitter.shortUrlLength;
            };
        },
    ]);
});
